import { render } from "./TheTextStyle.vue?vue&type=template&id=57e291fb&ts=true"
import script from "./TheTextStyle.vue?vue&type=script&lang=ts"
export * from "./TheTextStyle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__